module.exports = __webpack_public_path__ + "assets/img/Nexon-5-Landing-Page-w720.24a573d8.jpg";